'use client';

import * as React from 'react';
import { SizeContext } from "./SizeContext.js";
import { useChartContainerDimensions } from "./useChartContainerDimensions.js";

/**
 * The size provider.
 *
 * This differs from the DrawingProvider in that it provides the full size of the container.
 *
 * This provider is also responsible for resolving the size of the container before rendering and if the parent size changes.
 */
import { jsx as _jsx } from "react/jsx-runtime";
function SizeProvider(props) {
  const dimensions = useChartContainerDimensions(props.width, props.height);
  const value = React.useMemo(() => ({
    isInitialized: true,
    data: dimensions
  }), [dimensions]);
  return /*#__PURE__*/_jsx(SizeContext.Provider, {
    value: value,
    children: props.children
  });
}
export { SizeProvider };